/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Code which indicates the amount of solar collector overshading.
 */
export type SAPSolarCollectorOvershadingCodeUIDTOV0 = '1' | '2' | '3' | '4';

export const SAPSolarCollectorOvershadingCodeUIDTOV0 = {
    _1: '1' as SAPSolarCollectorOvershadingCodeUIDTOV0,
    _2: '2' as SAPSolarCollectorOvershadingCodeUIDTOV0,
    _3: '3' as SAPSolarCollectorOvershadingCodeUIDTOV0,
    _4: '4' as SAPSolarCollectorOvershadingCodeUIDTOV0
};

